// Module
var code = "<div class=\"switch\" id=\"switch-{{id}}-{{type}}\" ng-class=\"{\n        on: ngModel,\n        off: !ngModel,\n        animate: hasSwitched,\n        disabled: ngDisabled\n    }\" ng-click=\"toggle()\"> <div class=\"slider\"></div> </div> ";
// Exports
module.exports = code;